function replaceCharaterWithCode(str: string): string {
  // It is slower but alot more readable
  // https://jsbench.me/ttkzgsekae/1
  return str.split(``)
    .map(c => {
      const code = c.charCodeAt(0);
      return code >= 65 ? (code - 55).toString() : c;
    })
    .join(``);
}

function modulo(divident: string | number, divisor: number): number {
  divident = divident.toString();

  let remainder = 0;
  for (let i = 0; i < divident.length; ++i) {
    remainder = (remainder * 10 + parseInt(divident.charAt(i))) % divisor;
  }
  return remainder;
}

export function isValidIban(iban?: string): boolean {
  if (!iban) return false;

  iban = iban.replace(/\s/g, ``);
  const countryCode: string = iban.slice(0, 2);
  const providedChecksum: number = parseInt(iban.slice(2, 4), 10);
  const bban: string = iban.slice(4);

  // Wikipedia[validating_iban] says there is a specific way to check if an IBAN
  // is valid, but it says 'If the remainder is 1, the check digit test is
  // passed and the IBAN might be valid.'. might, MIGHT! We don't want might,
  // but want yes or no. IBAN consists of two country code chars, two check
  // digits and BBAN. We can calculate IBAN from BBAN and country code. We can
  // also extract BBAN and country code from IBAN.

  // To generate the (generate the iban check digits)[generating-iban-check]
  // * Move the country code to the end
  // * remove the checksum from the begging
  // * Add "00" to the end
  // * modulo 97 on the amount
  // * subtract remainder from 98, (98 - remainder)
  // * Add a leading 0 if the remainder is less then 10 (padStart(2, "0"))
  //   (we skip this since we compare int, not string)
  //
  // [validating_iban][https://en.wikipedia.org/wiki/International_Bank_Account_Number#Validating_the_IBAN]
  // [generating-iban-check][https://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits]

  const validationString = replaceCharaterWithCode(`${bban}${countryCode}00`);
  const rest = modulo(validationString, 97);
  return 98 - rest === providedChecksum;
}

